import { ErrorCodes } from '@shared';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeleteIntervalService } from '../services';
import { ValidationKeys } from '../../../../dynamic-form/validations/models';
import { DeleteChainParams, IDeleteValidatorHandler, IValidationsRule } from './models';
import { LoggingService } from '@shared/logging';
import { TableTypeProvider } from '@domain/business-layer';

export class ExternalCreatedCheck implements IDeleteValidatorHandler {
	private next: IDeleteValidatorHandler;

	public constructor(
		private deleteDataService: DeleteIntervalService,
		private loggerService: LoggingService,
		private tableTypeService: TableTypeProvider
	) {}

	public setNext(nextHandler: IDeleteValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(deleteChainParams: DeleteChainParams): Promise<IValidationsRule | null> {
		try {
			const isChildTable = await firstValueFrom(
				this.tableTypeService.isChildTable$(deleteChainParams.workfileId, deleteChainParams.tableName)
			);

			if (isChildTable && this.next) {
				return this.next.handle(deleteChainParams);
			}

			const externalCreatedCheck: IValidationsRule | null = await firstValueFrom(
				this.deleteDataService
					.isExternalCreatedRecord$(deleteChainParams.tableName, deleteChainParams.childEntryId)
					.pipe(
						map((isExternalCreated: boolean) =>
							isExternalCreated
								? null
								: { validationKey: ValidationKeys.validationRules.externalCreatedRule }
						)
					)
			);

			if (externalCreatedCheck) {
				return externalCreatedCheck;
			}

			if (this.next) {
				return this.next.handle(deleteChainParams);
			}

			return null;
		} catch (error) {
			this.loggerService.error(ErrorCodes.DeleteExternalCreatedError, error);
			throw error;
		}
	}
}
